import _ from 'lodash';
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import {
  FiltersInitialValue,
  FlightSearchTypeOptions,
  FlightSearchTypes,
} from '../../../../../constants';
import flightSearchInput from '../../../../../helpers/selectors/flightSearchInput';
import { setFlightTripSearchInputs } from '../../../../../store/slices/tripSearch';
import DropdownSelectFilter from '../../../../Filters/DropdownSelectFilter';
import { flightSearch } from '../../../../../store/slices/flight';
import { checkDoEnableDirectFlightSearch } from '../../../../../store/slices/user';

const FlightSearchTypesFilter = ({ tripId, textColorClass }) => {
  const dispatch = useDispatch();
  const { track } = useAnalytics();
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector(flightSearchInput(tripId, isTripSearch));
  const isDirectSellSearchEnabled = useSelector(checkDoEnableDirectFlightSearch);
  const filteredFlightSearchTypeOptions = useMemo(
    () =>
      _.omit(
        FlightSearchTypeOptions,
        isDirectSellSearchEnabled ? [] : [FlightSearchTypes.DIRECT_SELL],
      ),
    [isDirectSellSearchEnabled],
  );

  const handleChange = (newValue) => {
    const currentFlightSegments = [...searchInputs.flightSegments];
    let firstSegmentValue = currentFlightSegments[0];
    firstSegmentValue = _.omit(firstSegmentValue, [
      'preferredCabin',
      'timePreference',
      'flightTime',
      'rowIndex',
      'departureTimeWindow',
      'arrivalTimeWindow',
    ]);
    let newFlightSegments = [];

    if (newValue.flightSearchType === FlightSearchTypes.ONE_WAY) {
      newFlightSegments = [firstSegmentValue];
    } else if (newValue.flightSearchType === FlightSearchTypes.ROUND_TRIP) {
      newFlightSegments = [firstSegmentValue, {}];
    } else if (newValue.flightSearchType === FlightSearchTypes.MULTI_CITY) {
      newFlightSegments = [firstSegmentValue, {}];
    } else if (newValue.flightSearchType === FlightSearchTypes.DIRECT_SELL) {
      newFlightSegments = [firstSegmentValue];
    }
    const payload = {
      tripId,
      searchObj: {
        flightSearchType: newValue.flightSearchType,
        flightSegments: newFlightSegments,
        // Upon change of Flight Search Type, (i.e from Round-Trip to One-way etc) Reset values.
        avoidCabinDowngrade: FiltersInitialValue.flight.avoidCabinDowngrade,
        keepSameCabin: FiltersInitialValue.flight.keepSameCabin,
      },
    };
    if (isTripSearch) dispatch(setFlightTripSearchInputs({ ...payload.searchObj }));
    else dispatch(flightSearch(payload));
    track('flightSearchTypesFilter.handleChange', {
      ...(newValue || {}),
    });
  };

  return (
    <DropdownSelectFilter
      label={filteredFlightSearchTypeOptions[searchInputs.flightSearchType || 0].label}
      onChange={(newValue) => handleChange({ flightSearchType: newValue })}
      options={Object.values(filteredFlightSearchTypeOptions)}
      defaultOptionValue={FlightSearchTypes.ROUND_TRIP}
      selectedOptionValue={searchInputs.flightSearchType || FlightSearchTypes.ROUND_TRIP}
      menuWidth="w-64"
      filterButtonMaxWidth="max-w-full"
      filterSpacingClass="py-3 pr-3"
      variant={isTripSearch ? 'transparentWhiteFilterClasses' : 'text'}
      textColorClassName={isTripSearch ? textColorClass : ''}
    />
  );
};

FlightSearchTypesFilter.propTypes = {
  tripId: PropTypes.string,
  textColorClass: PropTypes.string,
};

FlightSearchTypesFilter.defaultProps = {
  tripId: undefined,
  textColorClass: 'text-tabsText-0',
};
export default memo(FlightSearchTypesFilter);
